import { render, staticRenderFns } from "./From.vue?vue&type=template&id=08438fc2&scoped=true&"
import script from "./From.vue?vue&type=script&lang=js&"
export * from "./From.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08438fc2",
  null
  
)

export default component.exports